import * as React from 'react';

import { EmailInput } from '@travelnest/merlin.email-input';
import theme from '@travelnest/merlin.theme';
import { focusComponent } from '../../helpers/components';
import { BlueButton, ErrorMessage, HelpFeaturedContainer } from './components';
import { friendlyMessage } from './helpers';

export interface ILoginEmailProps {
	initialEmail?: string;
	loading: boolean;
	error?: Error | null;
	focusInput?: boolean;
	onChange: (email: string) => void;
	onSubmit: () => void;
	onResetPassword: () => void;
}

// simple test for a@b.co
export const isValid = (email: string) => email.length >= 6 && email.indexOf('@') > 0 && email.indexOf('@') < email.lastIndexOf('.');

export const LoginEmail: React.FC<ILoginEmailProps> = ({
	initialEmail, onChange, onSubmit, onResetPassword, error, loading, focusInput
}) => {
	const [email, setEmail] = React.useState(initialEmail || '');
	const [showValidation, setShowValidation] = React.useState(false);
	const [valid, setValid] = React.useState(isValid(email));

	const dynamicProps = focusInput ? { ref: focusComponent } : {};
	const { message, action } = error ? friendlyMessage(error.message) : { message: null, action: null };

	return <HelpFeaturedContainer>
		<h1>Log in to your Travelnest account</h1>
		<form onSubmit={(e) => {
			e.preventDefault();
			if (email && valid) {
				onSubmit();
			} else {
				setShowValidation(true);
			}
		}}>
			<div>
				<h3 style={{ marginBottom: theme.layout.spacing.smallest }}>Email address</h3>
				<EmailInput
					id="login-email-input"
					required
					invalid={showValidation ? !valid : false}
					value={email}
					{...dynamicProps}
					onChange={({ email: nextEmail, valid: nextValid }) => {
						setEmail(nextEmail);
						setValid(nextValid);
						onChange(nextEmail);
					}}
				/>
			</div>
			{error && <ErrorMessage>
				{message}
				{action === 'reset' ? <><br /><a id="security-password-reset" href="#" onClick={() => onResetPassword()}>Reset your password.</a></> : null}
			</ErrorMessage>}
			<div style={{ marginTop: theme.layout.spacing.standard }}>
				<BlueButton disabled={!email} loading={loading}>Log in</BlueButton>
			</div>
		</form>
	</HelpFeaturedContainer>;
};
